export enum OnlineApplicationFlow {
  Direct,
  TwoStep,
  ThirdParty,
}
